export const ELIMINATION_DIET_DESCRIPTION =
  '3-month program with 1:1 coaching sessions';
export const VITAMIN_DESCRIPTION = '30-day supply';
export const TEST_KIT_DESCRIPTION = 'Test kit + results';
